import { createNamespacedHelpers } from 'vuex'

import { namespace } from '../vuexstore'
import { default as cartStore, namespace as cartStoreNamespace } from '../vuexstore/modules/cart'
const { mapGetters, mapActions } = createNamespacedHelpers([namespace, cartStoreNamespace].join('/'))

export default {
  computed: {
    ...mapGetters(Object.keys(cartStore.getters)),
  },

  methods: {
    ...mapActions(Object.keys(cartStore.actions)),
  }
}
